import React, { useState, useContext } from "react";
import Navigation from "../../components/navigation";
import StaffView from "../../views/StaffView";
import { PageContext } from "../../hooks/pageContext";

export default function StaffDisplay() {
  const tabs = [
    { title: "Home", href: "/staffdisplay" },
    { title: "Food", href: "/menu" },
    { title: "Translators", href: "/translate" },
  ];

  const auth = useContext(PageContext);

  return (
    <div className="h-screen w-screen bg-black">
      <StaffView />
      <Navigation tabs={tabs} />
    </div>
  );
}
